import React from 'react'
import Select, {components} from "react-select";
import { useSelector} from "react-redux";
import $ from "jquery";
const ReactMultiSelect = React.forwardRef((props, reference) => {

const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
const LimitedChipsContainer = ({ children, hasValue, ...props }) => {
if (!hasValue) {
    return (
    <components.ValueContainer {...props}>
        {children}
    </components.ValueContainer>
    );
}
var langNames = []
const CHIPS_LIMIT = 20;
const [chips, otherChildren] = children;
const overflowCounter1 = chips.length;
const overflowCounter = chips.slice(CHIPS_LIMIT).length;
const displayChips = chips.slice(
    overflowCounter,
    overflowCounter + CHIPS_LIMIT
);
displayChips.map((chip)=>{
    if(chip.props.children !== 'Check All'){
    langNames.push(chip.props.children)
}
    if(chip.props.children.length === 0){
    langNames = 'none'
    }
})
$(".language-dropdown span:first").attr("aria-label", langNames.length + " selected - " + langNames + ". Press down arrow key to open the menu and select/unselect options.");
return (
    <components.ValueContainer {...props}>

    <div id="selected-lang-container" style={{marginTop: "-28px"}} role="status" aria-label={langNames + ' selected'} >{overflowCounter1 > 0 && ` ${overflowCounter1 } selected`}</div>

    {otherChildren}
    </components.ValueContainer>
);
};
const options = props.option
const callBack = props.callback
const Option = (props) => {
return props.data.value !== "all" && props.data.value !== "none" ? (
    <components.Option {...props}>
    <input
        tabIndex={0}
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        id={props.label}
    />{" "}
    <label htmlFor={props.label}>{props.label}</label>
    </components.Option>
) : (
    <components.Option {...props}>
    <label
        style={{ fontWeight: 600, fontSize: "14px" }}
        htmlFor={props.label}
    >
        {props.label}
    </label>
    <button
        style={{
        fontWeight: 600,
        fontSize: "14px",
        display: "none",
        color: aaaSelected ? "#fff" : "#000",
        }}
        aria-label={props.label}
    >
        {" "}
        {props.label}{" "}
    </button>
    </components.Option>
);
};
const CustomClearText = () => '';
const ClearIndicator = (props) => {
const {
    children = <CustomClearText />,
    innerProps: { ref, ...restInnerProps },
} = props;
return (
    <div {...restInnerProps} ref={ref}>
    {children}
    </div>);
}; 
const IndicatorsContainer = (props) => {
    return (
      <div style={{ marginLeft: "10px" }}>
        <components.IndicatorsContainer {...props} />
      </div>
    );
};

const setFocus = (data) => {
    setTimeout(() => {
        reference.current.focus();
    }, 100);
    callBack(data)
}


  return (
   
        <Select classNamePrefix='cw'
            ref={reference}
            className={props.filterType === "tasks" ? "lastOutFocus" : "global-dropdown-select lastOutFocus"}
            value={props.value}
            aria-label={props.ariaLabel}
            isMulti
            placeholder={props.placeholder}
            allowSelectAll={true}
            hideSelectedOptions={false}
            closeMenuOnSelect={false}
            options={options.length === 2 ? options.slice(2) : options} 
            onChange={(selected) => {
            selected.length &&
            selected.find((option) => option.value === "all")
                ? setFocus(options.slice(2))
                : selected.find((option) => option.value === "none") 
                ? setFocus([])
                : setFocus(selected);
            }}
            onInputChange={(e) => props.inputChange(e)}
            components={{
            ValueContainer: LimitedChipsContainer,
            Option,
            ClearIndicator,
            IndicatorsContainer,
            }}
        />
   
  )
});
ReactMultiSelect.propTypes = {};

export default ReactMultiSelect;
